import { render, staticRenderFns } from "./ProjeDuzenle.vue?vue&type=template&id=a565b8fc&scoped=true&"
import script from "./ProjeDuzenle.vue?vue&type=script&lang=js&"
export * from "./ProjeDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./ProjeDuzenle.vue?vue&type=style&index=0&id=a565b8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a565b8fc",
  null
  
)

export default component.exports